import { render, staticRenderFns } from "./QaEdit.vue?vue&type=template&id=4ed5c097&scoped=true"
import script from "./QaEdit.vue?vue&type=script&lang=js"
export * from "./QaEdit.vue?vue&type=script&lang=js"
import style0 from "./QaEdit.vue?vue&type=style&index=0&id=4ed5c097&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed5c097",
  null
  
)

export default component.exports